import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import * as React from 'react'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useStuartMutate } from '../../../APIs/Hooks/PhpAPIHooks'
import { useScreenContext } from '../../../Contexts/Modules/HealthModule/SelectedScreenModule'
import { useParams } from 'react-router-dom'
import { useQueryClient } from 'react-query'

function ConfirmAbortScreenDialog({
  open,
  setOpen,
}: {
  open: boolean
  setOpen: any
}) {
  const queryClient = useQueryClient()
  const { screen_id } = useParams()
  const { screenQuery } = useScreenContext()
  const { setMessage } = useMessagePopupContext()

  const { mutate: updateScreen } = useStuartMutate(
    `/screen/updateScreen.php?ScreenID=${screen_id}&CollectionStatus=ARC&BillingStatus=${screenQuery.data?.BillingStatus}`,
    async (data) => {
      if (data?.message) {
        setMessage({
          subject: 'Error',
          severity: 'warning',
          message: data.message,
        })
      } else {
        setOpen(false)
        await queryClient.invalidateQueries({
          queryKey: ['PhpAPI', '/stuart', '/screen/getScreen.php'],
        })
      }
    },
  )

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle>{'Are you sure?'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This action cannot be undone. All holding and collection requests
          linked to this screen will be aborted and archived.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="error"
        >
          Cancel
        </Button>
        <Button
          onClick={() => updateScreen()}
          color="warning"
        >
          Confirm Abort
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmAbortScreenDialog
